import * as React from "react";

const SvgIconPlus = (props) => {
  return (
    <svg width={31.002} height={31.002} viewBox="0 0 8.203 8.203" {...props}>
      <g
        transform="translate(-92.661 -137.26)"
        stroke="#c1cacc"
        strokeLinecap="round"
      >
        <rect
          x={92.926}
          y={137.53}
          width={7.673}
          height={7.673}
          rx={1.279}
          ry={1.279}
          fill="#fff"
          strokeWidth={0.511}
        />
        <g fill="#414a4f" strokeWidth={0.529}>
          <path
            d="M96.762 139.02v4.686M99.105 141.363h-4.686"
            strokeWidth={0.46844008000000004}
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgIconPlus;
